import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  SearchFilter,
  SearchFilterContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-search-filter',
  template: SearchFilter.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFilterComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = SearchFilter.height;
  @Input() public viewBox: string = getSVGViewBox(SearchFilter.viewBox);
  @Input() public width: number | string = SearchFilter.width;
  @Input()
  public set context(ctx: SearchFilterContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: SearchFilterContext = SearchFilter.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = SearchFilterComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : SearchFilter.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
